import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Instructions from '../views/Instructions.vue'
import Pasture from '../views/Pasture.vue'
import Livestock from '../views/livestock/Index.vue'
import LivestockCattle from '../views/livestock/Cattle.vue'
import LivestockSheep from '../views/livestock/Sheep.vue'
import Feed from '../views/feed/Index.vue'
import FeedSupply from '../views/feed/Supply.vue'
import FeedDemand from '../views/feed/Demand.vue'
import Calculations from '../views/_hidden/Calculations.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    alias: '',
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/instructions',
    name: 'Instructions',
    component: Instructions
  },
  {
    path: '/pasture',
    name: 'Pasture',
    component: Pasture
  },
  {
    path: '/livestock/',
    name: 'Livestock',
    component: Livestock,
    children: [
      {
        alias: '',
        path: 'cattle',
        name: 'Cattle',
        component: LivestockCattle
      },
      {
        path: 'sheep',
        name: 'Sheep',
        component: LivestockSheep
      }
    ]
  },
  {
    path: '/feed/',
    name: 'Feed',
    component: Feed,
    children: [
      {
        alias: '',
        path: 'demand',
        name: 'Demand',
        component: FeedDemand
      },
      {
        path: 'supply',
        name: 'Supply',
        component: FeedSupply
      }
    ]
  },

  // Hidden

  {
    path: '/calculations',
    name: 'Calculations',
    component: Calculations
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// Navigation guards
router.beforeEach((to, from, next) => {
  // If pasture errors exist then prevent navigation
  if (
    from.name === 'Pasture' &&
    (to.name === 'Livestock' || to.name === 'Cattle' || to.name === 'Sheep' || to.name === 'Feed' || to.name === 'Demand' || to.name === 'Supply') &&
    store.state.errors &&
    store.state.errors.pasture &&
    store.state.errors.pasture.length > 0
  ) {
    next({ name: 'Pasture' })
  // If livestock errors exist then prevent navigation
  } else if (
    (from.name === 'Livestock' || from.name === 'Cattle' || from.name === 'Sheep') &&
    (to.name === 'Feed' || to.name === 'Demand' || to.name === 'Supply') &&
    store.state.errors &&
    store.state.errors.livestock &&
    store.state.errors.livestock.length > 0
  ) {
    next({ name: store.state.pasture?.simulation.enterprise?.includes('Cattle') ? 'Cattle' : 'Sheep' })
  } else {
    next()
  }
})

export default router
